import styled from 'styled-components';
import { media, mediaQuery } from '../../../common/styles/styleUtil';

export const ProjectInformationWrapper = styled.div`
  width: 100%;
  padding-bottom: 24px;
`;

export const ProjectInfoHeroImage = styled.div`
  position: relative;
  height: 200px;
  ${media.xs`
    height: 180px;
  `}
  .lazy-image-wrapper {
    height: 100%;
  }
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const ImageOverlay = styled.div`
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 90px;
  background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0), #000000);
  opacity: 0.7;
`;

export const ProjectInfoCaption = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  position: absolute;
  padding: 16px;
  bottom: 0;
  width: 100%;
  color: #ffffff;
  @media (${mediaQuery.mobile}) {
    padding: 8px;
  }
  .view-project-btn {
    padding: 8px 16px;
    color: #ffffff;
    background: none;
    line-height: 24px;
    height: auto;
    border-radius: 3px;
    border: solid 1px #ffffff;
    align-self: flex-end;
    transition: all 0.4s;
    &:hover {
      background-color: #ffffff;
      color: #333f48;
    }
    span {
      font-size: 16px;
      font-weight: 400;
    }
  }
`;

export const ProjectInfoTitle = styled.div`
  line-height: normal;
  word-break: break-word;
  p {
    width: 100%;
    margin: 0;
    padding: 0 24px 0 0;
    font-size: 20px;
    font-weight: 400;
    line-height: 26px;
    text-shadow: 0 1px 2px #000000;
    color: #ffffff;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    display: -webkit-box;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    @media (${mediaQuery.mobile}) {
      font-size: 20px;
      -webkit-line-clamp: 3;
    }
  }
`;

export const ProjectInfoAttribute = styled.div`
  width: 100%;
  display: flex;
  margin-top: 24px;
  @media (${mediaQuery.mobile}) {
    flex-direction: column;
  }
  .attribute-detail {
    width: 50%;
    @media (${mediaQuery.mobile}) {
      width: 100%;
    }
    &.price-info {
      @media (${mediaQuery.mobile}) {
        margin-top: 16px;
      }
    }
    span {
      font-size: 14px;
      font-weight: 300;
      line-height: 14px;
      letter-spacing: 1px;
      color: #697684;
    }
    p {
      margin: 4px 0 0;
      padding: 0;
      font-size: 16px;
      line-height: 26px;
      font-weight: 300;
      color: #333f48;
    }
  }
`;
